import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button, Form, FormControl } from "react-bootstrap";

const SearchBox = ({
  className = "",
  placeholder,
  searchParamData,
  handleSearchChange,
  handleClearSearch,
}) => {
  return (
    <div
      className={
        `search-section ${className}` +
        `${searchParamData ? " clear-text" : ""}`
      }
    >
      <Form>
        <FormControl
          onChange={(e) => handleSearchChange(e)}
          type="text"
          value={searchParamData ? searchParamData : ""}
          placeholder={placeholder}
        />
        {searchParamData ? (
          <FontAwesomeIcon
            className="clearTextIcon"
            icon={faXmark}
            size="1x"
            onClick={() => handleClearSearch()}
          />
        ) : (
          <Button className="fa fa-search">Search</Button>
        )}
      </Form>
    </div>
  );
};

export default SearchBox;
